import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, ShieldCheck, Clock, FileText } from "lucide-react";
import api, { BACKEND_URL } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import DangerZone from "./DangerZone";

export default function PrivacyPanel() {
    const { user } = useAuth();
    const [privacy, setPrivacy] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/account/privacy");
            setPrivacy(data);
        } catch (e) {
            console.error("privacy load failed", e);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const isManager = user?.role === "responsable" || user?.role === "admin";

    return (
        <section className="mt-10" data-testid="privacy-panel">
            <div className="label-eyebrow flex items-center gap-2"><ShieldCheck size={14} className="text-orange" /> Données et confidentialité</div>
            <h2 className="h-display text-2xl font-semibold mt-1">Vos droits RGPD</h2>

            <div className="grid sm:grid-cols-2 gap-4 mt-5">
                <div className="panel p-5" data-testid="account-data-export-card">
                    <Download size={18} className="text-orange" />
                    <h3 className="h-display text-base font-semibold mt-2">Exporter mes données</h3>
                    <p className="text-xs text-muted2 mt-1 mb-3">Fichier JSON avec profil, bilans, évaluations, messages, RDV, bulletins et fichiers (art. 15 et 20).</p>
                    <a href={`${BACKEND_URL}/api/account/data-export`} className="btn-outline !text-xs !px-3 !py-2 inline-flex" data-testid="account-download-data-button">
                        <Download size={12} /> Télécharger (JSON)
                    </a>
                </div>
                <div className="panel p-5" data-testid="account-retention-card">
                    <Clock size={18} className="text-orange" />
                    <h3 className="h-display text-base font-semibold mt-2">Durée de conservation</h3>
                    <p className="text-xs text-muted2 mt-1">
                        Les données des étudiants sont anonymisées 12 mois après la fin de leur formation. Le responsable est prévenu 60, 30 et 7 jours avant.
                    </p>
                    {privacy?.purge_at && (
                        <p className="text-xs font-medium mt-2" data-testid="account-purge-date">
                            Anonymisation prévue le {new Date(privacy.purge_at).toLocaleDateString("fr-FR")}.
                        </p>
                    )}
                    <p className="text-xs text-muted2 mt-2">Pour corriger une information, modifiez votre profil ci-dessus ou écrivez à contact@profawz.fr.</p>
                </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-4 text-xs">
                <Link to="/confidentialite" className="inline-flex items-center gap-1 text-orange hover:underline" data-testid="privacy-policy-link"><FileText size={12} /> Politique de confidentialité</Link>
                <Link to="/cookies" className="inline-flex items-center gap-1 text-orange hover:underline" data-testid="privacy-cookies-link"><FileText size={12} /> Politique cookies</Link>
                {isManager && (
                    <Link to="/conformite" className="inline-flex items-center gap-1 text-orange hover:underline" data-testid="privacy-compliance-link"><ShieldCheck size={12} /> Purges à venir et journal d'audit</Link>
                )}
            </div>

            <DangerZone privacy={privacy} onChanged={load} />
        </section>
    );
}
